import { render } from "./BackLink.vue?vue&type=template&id=2705e0a0&scoped=true"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"

import "./BackLink.vue?vue&type=style&index=0&id=2705e0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2705e0a0"]])

export default __exports__